export enum ShipmentType {
    Delivery = 0,
    PickUp   = 1
}

export const ShipmentTypeMetadata = {
    '0': {
        display: 'Delivery',
        value: 0
    },
    '1': {
        display: 'Pick-Up',
        value: 1
    }
};
